import React from "react";
import leftPng from "../../../../content/images/left.png";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Discipline in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Discipline
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam discipline</div>
            <div className="box-title-2-active" id="algemeenNaam" />
            <span
              className="tooltiptext detail"
              id="algemeenNaam-tooltip"
            ></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="discipline_active" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
